module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-thunder-1856ce8406fc20c85601a51050af8100.svg";